module.exports = __webpack_public_path__ + "img/mv_hero_pc.d9bc2842.jpg";